// Función para verificar si un elemento está en la vista
function elementoEnVista(elemento) {
  const rect = elemento.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

// Función para reiniciar los contadores a 0
function reiniciarContadores() {
  const contadorItems = document.querySelectorAll('.contador-numero');

  contadorItems.forEach((item) => {
    item.innerText = '0';
  });
}

// Detectar cuando el usuario hace scroll
window.addEventListener('scroll', () => {
  const contadorItems = document.querySelectorAll('.contador-numero');

  contadorItems.forEach((item) => {
    if (elementoEnVista(item)) {
      const target = +item.getAttribute('data-contador');
      const current = +item.innerText;
      const increment = target / 100; // Controla la velocidad de la animación

      if (current < target) {
        item.innerText = Math.ceil(current + increment);
      }
    } 
  });
});

//Traducciones para calendario en ingles
var fecha_calendario = document.getElementsByClassName(".eapp-events-calendar-dates-inputText");

if (fecha_calendario.length > 0) {
  // Modifica el texto del primer elemento encontrado
  fecha_calendario[0].textContent = "Fecha";
}

